

























import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import SlotModal from "../../menu/components/SlotModal.vue";
import { IOrderCancellationRequestDto } from "../../../types/interface/IOrderCancellationRequestDto";
import {
  IOrderItemDto,
  canceledOrderItemInfo
} from "../../../types/interface/IOrderItem";
import { orderCancellationRequestDto } from "../../../types/impl/IOrderCancellationRequestDto";
@Component({
  components: {
    SlotModal
  }
})
export default class RefundDetail extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: () => ({ ...orderCancellationRequestDto }) })
  refundOrder!: IOrderCancellationRequestDto;

  public get refundItemList(): IOrderItemDto[] {
    const refundItemsId: string[] = this.refundOrder.orderCancellationItems.map(
      item => item.id
    );
    const refundItemList: IOrderItemDto[] = refundItemsId.map(itemId => {
      return this.refundOrder.order.orderItems.find(item => {
        return item.id === itemId;
      }) as IOrderItemDto;
    });
    return refundItemList;
  }

  getRefundReason(refundItem: IOrderItemDto): string {
    const refundReason: string = this.refundOrder.reason // 旧版本的退款原因
      ? (this.refundOrder.reason as string).trim()
      : "";
    let canceledOrderItemInfoReason: string = ""; // 新版本的退款原因
    if (refundItem.canceledOrderItemInfo) {
      canceledOrderItemInfoReason = (refundItem.canceledOrderItemInfo as canceledOrderItemInfo)
        .reason
        ? ((refundItem.canceledOrderItemInfo as canceledOrderItemInfo)
            .reason as string)
        : "";
    }

    return refundReason || canceledOrderItemInfoReason;
  }

  isShowImg(canceledOrderItemInfo: canceledOrderItemInfo | null): Boolean {
    if (canceledOrderItemInfo && canceledOrderItemInfo.photos)
      return !!canceledOrderItemInfo.photos.length;
    return false;
  }

  close() {
    this.$emit("close");
  }
}
